module.exports = __webpack_public_path__ + "img/Flag_of_Morocco.c182eaf4.svg";